var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconApproved(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_00000038379755125385895050000017070595738289298865_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_03.like"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m312.8 501.1c-35.5 0-70.9.2-106.4-.2-5.5-.1-11.4-2.3-16.5-5-25.4-15.3-45.6-36.3-43.7-68.9 1.7-57.9.6-115.9.4-173.9-.1-12.9 4.7-22.6 14.2-31.2 66-57.7 111.3-97.5 119.1-190.3 10.1-43.5 69.3-13.6 71.6 20.1 17.2 73.6-40.9 141.6-8.7 138.6 39.2 1.4 78.4 2.7 117.6 4 29 .9 52.5 26 51.7 58.8-4.7 63.5-17.9 126.5-24.3 189.9-13.9 82.1-116 52.8-175 58.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17.6 218.4h86.4c9.7 0 17.6 7.9 17.6 17.6v244.3c0 9.7-7.9 17.6-17.6 17.6h-86.4c-9.7.1-17.6-7.8-17.6-17.6v-244.2c0-9.8 7.9-17.7 17.6-17.7z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconApproved);
export default __webpack_public_path__ + "static/media/icon-approved.cbc917da15695da44d5182f164c09210.svg";
export { ForwardRef as ReactComponent };